export default __webpack_public_path__ + "static/Stop electricians from clocking in until they arrive on-site@2x-2eac0c0f2494fa958844ca9f09e335ba.png";